import * as def from '@/definitions'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { ArrayHelper } from '@/helper/arrayHelper';
import { FontManager } from '@/model/fontManager/fontManager';

export class TableCellInfo2
{
    // 背景色
    private _backgroundColor = new ColorConstruct(255, 255, 255);
    public get backgroundColor() { return this._backgroundColor; }
    public set backgroundColor(backgroundColor) { this._backgroundColor = backgroundColor; }

    // 幅 (レイヤーの幅100に対して正規化)
    private _cellWidthNormalized = 100;
    public get cellWidthNormalized() { return this._cellWidthNormalized; }
    public set cellWidthNormalized(cellWidthNormalized) { this._cellWidthNormalized = cellWidthNormalized; }

    // 高さ (レイヤーの高さ100に対して正規化)
    private _cellHeightNormalized  = 100;
    public get cellHeightNormalized () { return this._cellHeightNormalized ; }
    public set cellHeightNormalized (cellHeightNormalized ) { this._cellHeightNormalized  = cellHeightNormalized ; }

    // 複製
    public clone()
    {
        var cloned = new TableCellInfo2();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(info : TableCellInfo2)
    {
        info.backgroundColor = this.backgroundColor.clone();
        info.cellWidthNormalized = this.cellWidthNormalized;
        info.cellHeightNormalized = this.cellHeightNormalized;
        return info;
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.backgroundColor = this.backgroundColor;
        jsonObject.cellWidthNormalized = this.cellWidthNormalized;
        jsonObject.cellHeightNormalized = this.cellHeightNormalized;
        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : TableCellInfo2
    {
        var layer = new TableCellInfo2();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.backgroundColor != null) { this.backgroundColor = ColorConstruct.createFromJsonData(jsonData.backgroundColor); }
        if(jsonData.cellWidthNormalized != null) { this.cellWidthNormalized = jsonData.cellWidthNormalized; }
        if(jsonData.cellHeightNormalized != null) { this._cellHeightNormalized = jsonData.cellHeightNormalized; }
    }
}